import React from 'react';
import s from './s.module.less';
import { Drawer, Modal } from 'antd';
import { TPaymentBilling, TPaymentEvent, TBillingFrom } from 'types/provider';
import { getPaymentEventList, getTextVisitPaymentEventList } from 'api/provider';
import { gpGetBillingEvents } from 'api/group';
import PaymentEvent from './PaymentEvent';

interface Props {
    open?: boolean;
    onCancel?: () => void;
    item?: TPaymentBilling;
    isGroupPractice?: boolean;
}

const PaymentEventModal = ({ open, onCancel, item, isGroupPractice }: Props) => {
    const [timelineData, setTimelineData] = React.useState<TPaymentEvent[]>([]);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        const fetchData = async () => {
            if (open && item && item.id) {
                setLoading(true);
                let res;
                if (isGroupPractice && item.billingFrom === TBillingFrom.KLARITY_USER_BILLING) {
                    res = await gpGetBillingEvents(item.id);
                } else if (item.billingFrom === TBillingFrom.KLARITY_USER_BILLING) {
                    res = await getTextVisitPaymentEventList(item.id);
                } else {
                    res = await getPaymentEventList(item.id);
                }
                if (!res.error) {
                    const list = res?.data?.data || [];
                    //todo
                    // setTimelineData([
                    //     ...list,
                    //     ...list,
                    //     ...list,
                    //     ...list,
                    //     ...list,
                    //     ...list,
                    // ]);
                    setTimelineData(list);
                }
                setLoading(false);
            }
        };
        if (open && item && item.id) {
            fetchData();
        }
        if (!open) {
            setTimelineData([]);
        }
    }, [open, item]);

    return (
        <Modal
            centered
            title="View transaction details"
            open={open}
            onCancel={onCancel}
            footer={null}
            width={500}
            destroyOnClose
            wrapClassName={s.viewDetailModalWrap}
            className={s.viewDetailModal}
        >
            <PaymentEvent data={timelineData} loading={loading} />
        </Modal>
    );
};

export default PaymentEventModal;
